export default {
      id: "fuel-usage",
      viewBox: "0 0 28 31",
      url: __webpack_public_path__ + "img/icons.svg#fuel",
      toString: function () {
        return this.url;
      }
    }